import type { TagColor } from '@chatsdet/ui';
import type { TicketingProviderSummary } from '../hooks/useTicketingProviders';

const FALLBACK_PROVIDER_LABELS: Record<string, string> = {
  azureDevops: 'Azure DevOps',
  github: 'GitHub',
  jira: 'Jira',
  linear: 'Linear',
};

const PROVIDER_BADGE_COLORS: Record<string, TagColor> = {
  azureDevops: 'gray',
  github: 'gray',
  jira: 'blue',
  linear: 'purple',
};

export function getTicketingProviderLabel(
  providerId: string,
  providers: TicketingProviderSummary[] = []
): string {
  return (
    providers.find((provider) => provider.id === providerId)?.displayName ??
    FALLBACK_PROVIDER_LABELS[providerId] ??
    providerId
  );
}

export function getTicketingProviderColor(providerId: string): TagColor {
  return PROVIDER_BADGE_COLORS[providerId] ?? 'gray';
}

export function formatTicketingProviderLinkLabel(
  providerId: string,
  identifier: string | null,
  providers: TicketingProviderSummary[] = []
): string {
  const suffix = identifier ? ` ${identifier}` : '';
  if (providerId === 'github') return `View pull request${suffix}`;
  return `View ${getTicketingProviderLabel(providerId, providers)} ticket${suffix}`;
}
